import React, { useEffect, useState } from 'react';
import { PLATFORMS, TABS } from './marketingChannels';
import { useInView } from './shared';

const ROTATE_MS = 6000;

/** One brand circle: logo, hand-built wordmark, or monogram fallback. */
const PlatformMark = ({ platform }) => {
  if (platform.logo) {
    return (
      <span className={`ilp-mr-logo${platform.fullBleed ? ' is-fullbleed' : ''}`}>
        <img src={platform.logo} alt={`${platform.name} logo`} />
      </span>
    );
  }
  if (platform.wordmark === 'booking') {
    return (
      <span className="ilp-mr-wordmark" aria-hidden="true">
        <span style={{ color: '#003580' }}>B</span>
        <span style={{ color: '#0896FF' }}>.</span>
      </span>
    );
  }
  return (
    <span className="ilp-mr-monogram" style={{ color: platform.color }} aria-hidden="true">
      {platform.monogram}
    </span>
  );
};

/** "Ready for leads when you are" — tabs auto-rotate once scrolled into view. */
const MarketingReady = () => {
  const [active, setActive] = useState('social');
  const { ref, inView } = useInView(0.35);

  useEffect(() => {
    if (!inView) return undefined;
    const id = setInterval(() => {
      setActive((prev) => {
        const i = TABS.findIndex((t) => t.key === prev);
        return TABS[(i + 1) % TABS.length].key;
      });
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, [inView]);

  const platforms = PLATFORMS[active];
  const description = TABS.find((t) => t.key === active).description;

  return (
    <section ref={ref} className="ilp-mr">
      <div className="ilp-mr-card">
        <p className="ilp-eyebrow ilp-mr-eyebrow">Your brand, marketing ready</p>
        <h2 className="ilp-mr-title">Ready for leads when you are</h2>

        <div className="ilp-mr-tabs" role="tablist">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={active === tab.key}
              onClick={() => setActive(tab.key)}
              className={`ilp-mr-tab${active === tab.key ? ' is-active' : ''}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <p key={`${active}-desc`} className="ilp-mr-desc ilp-fade-slide">
          {description}
        </p>

        <div key={active} className="ilp-mr-stack">
          {platforms.map((p, i) => (
            <div
              key={p.name}
              className="ilp-mr-item ilp-brand-stack"
              style={{ animationDelay: `${i * 70}ms`, zIndex: platforms.length - i }}
            >
              <span className="ilp-mr-circle">
                <PlatformMark platform={p} />
              </span>
              <span className="ilp-mr-tip">{p.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketingReady;
